import axiosClient from "../../../../system/helpers/axiosConfig";

export const getTerms = (params) => {
  return axiosClient
    .get(`/api/translation`, {
      params,
    })
    .then((r) => r.data);
};
